import { MiniPlayerState } from "../types/MiniPlayerState";

export const state: MiniPlayerState = {
    object: null,
    videoController: null,
    showPlayer: false,
    paused: false,
    returnRouteName: ""
}